export default {
  modals: state => state.modals.items,
  activeModalId: state=> state.modals.active,
}